/**
 * Encryption of dialogue messages between accounts.
 */

import { CryptoContext } from '../base';
import { DialogueConfigDumpArgs, DialogueConfigLoadArgs } from './args';
import { DialogueConfigV1 } from './v1';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';
import { DialogueConfigV2, DialogueConfigV3 } from './v2_v3';

export let DIALOGUE_CRYPTO_CONTEXT = new CryptoContext<
  DialogueConfigLoadArgs,
  DialogueConfigDumpArgs
>([
  new DialogueConfigV1(CU_ANNULLED_BY_PQC_ML),
  new DialogueConfigV2(CU_PQC_ML),
  new DialogueConfigV3(CU_PQC_ML),
]);
